import React, { useEffect, useState, useRef, createElement } from 'react';
import { CheckIcon, XIcon, ChevronDownIcon, ChevronUpIcon, ShieldCheckIcon, SmartphoneIcon, LeafIcon, LockIcon } from 'lucide-react';
const PIXEL_ID = '1105594269297700';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  if (!type) return null;
  const isPrivacy = type === 'privacy';
  const privacyContent = <>
      <p className="mb-4" data-id="element-2">Última actualización: enero 2025</p>
      <p className="mb-4" data-id="element-3">
        En <strong data-id="element-4">Libido Express</strong> nos comprometemos a proteger tu
        privacidad. Esta política describe cómo recopilamos, usamos y protegemos
        tu información personal.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-5">
        1. Información que recopilamos
      </h3>
      <p className="mb-4" data-id="element-6">
        Al realizar tu compra, recopilamos únicamente tu dirección de correo
        electrónico para enviarte el acceso a tu producto digital. No
        recopilamos información de pago directamente; esta es procesada de forma
        segura por nuestro proveedor de pagos.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-7">
        2. Uso de la información
      </h3>
      <p className="mb-4" data-id="element-8">
        Tu correo electrónico se utiliza exclusivamente para: (a) entregar tu
        producto digital, (b) enviarte comunicaciones relacionadas con tu
        compra. No vendemos, alquilamos ni compartimos tu información con
        terceros.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-9">
        3. Seguridad
      </h3>
      <p className="mb-4" data-id="element-10">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información. Toda la transmisión de datos se realiza
        mediante cifrado SSL.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-11">
        4. Cookies
      </h3>
      <p className="mb-4" data-id="element-12">
        Este sitio puede utilizar cookies técnicas necesarias para su
        funcionamiento. No utilizamos cookies de rastreo de terceros con fines
        publicitarios.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-13">
        5. Tus derechos
      </h3>
      <p className="mb-4" data-id="element-14">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tus
        datos personales en cualquier momento. Para ejercer estos derechos,
        puedes comunicarte con nosotros a través de los canales indicados en tu
        correo de confirmación de compra.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-15">
        6. Cambios a esta política
      </h3>
      <p data-id="element-16">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
  const termsContent = <>
      <p className="mb-4" data-id="element-17">Última actualización: enero 2025</p>
      <p className="mb-4" data-id="element-18">
        Al adquirir <strong data-id="element-19">Libido Express</strong>, aceptas los siguientes
        términos y condiciones. Por favor, léelos detenidamente antes de
        completar tu compra.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-20">
        1. Naturaleza del producto
      </h3>
      <p className="mb-4" data-id="element-21">
        Libido Express es un producto de información digital (eBook/PDF) de
        carácter educativo e informativo. No constituye consejo médico,
        diagnóstico ni tratamiento de ninguna condición de salud. Siempre
        consulta a un profesional de la salud antes de iniciar cualquier
        protocolo de bienestar.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-22">
        2. Acceso y entrega
      </h3>
      <p className="mb-4" data-id="element-23">
        Tras la confirmación de pago, recibirás acceso inmediato a tu producto
        digital. El acceso es personal e intransferible. No está permitida la
        redistribución, reventa o reproducción del contenido.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-24">
        3. Política de reembolso
      </h3>
      <p className="mb-4" data-id="element-25">
        Dado que se trata de un producto digital con acceso inmediato, no se
        ofrecen reembolsos una vez que el acceso ha sido entregado, salvo en
        casos de error técnico comprobable de nuestra parte.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-26">
        4. Propiedad intelectual
      </h3>
      <p className="mb-4" data-id="element-27">
        Todo el contenido de Libido Express, incluyendo textos, gráficos y
        metodologías, es propiedad exclusiva de sus autores y está protegido por
        las leyes de derechos de autor aplicables. Queda prohibida su
        reproducción total o parcial sin autorización expresa.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-28">
        5. Limitación de responsabilidad
      </h3>
      <p className="mb-4" data-id="element-29">
        Los resultados descritos son experiencias individuales y no garantizan
        resultados idénticos para todos los usuarios. La efectividad del
        protocolo puede variar según la situación personal de cada usuaria.
      </p>
      <h3 className="font-bold mb-2 mt-5" style={{
      fontFamily: 'Playfair Display, serif',
      color: '#6B2D3E'
    }} data-id="element-30">
        6. Ley aplicable
      </h3>
      <p data-id="element-31">
        Estos términos se rigen por las leyes aplicables en la jurisdicción del
        vendedor. Cualquier disputa será resuelta de buena fe entre las partes.
      </p>
    </>;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" style={{
    background: 'rgba(44, 24, 16, 0.65)',
    backdropFilter: 'blur(6px)'
  }} onClick={onClose} data-id="element-32">
      <div className="relative w-full max-w-2xl max-h-[85vh] rounded-3xl overflow-hidden flex flex-col" style={{
      background: '#FAF6F0',
      boxShadow: '0 32px 80px rgba(44,24,16,0.35)'
    }} onClick={e => e.stopPropagation()} data-id="element-33">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-8 py-5 flex-shrink-0" style={{
        background: 'linear-gradient(135deg, #6B2D3E 0%, #8B3A50 100%)'
      }} data-id="element-34">
          <h2 className="text-xl font-bold" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#FAF6F0'
        }} data-id="element-35">
            {isPrivacy ? 'Política de Privacidad' : 'Términos de Uso'}
          </h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center transition-colors hover:bg-white/20" style={{
          color: '#FAF6F0'
        }} aria-label="Cerrar" data-id="element-36">
            <XIcon className="w-5 h-5" data-id="element-37" />
          </button>
        </div>

        {/* Gold accent line */}
        <div className="h-0.5 flex-shrink-0" style={{
        background: 'linear-gradient(90deg, #C9A07A, #E8C4B8, #C9A07A)'
      }} data-id="element-38" />

        {/* Scrollable Content */}
        <div className="overflow-y-auto px-8 py-6 text-sm leading-relaxed flex-1" style={{
        fontFamily: 'Lato, sans-serif',
        color: '#4A3728'
      }} data-id="element-39">
          {isPrivacy ? privacyContent : termsContent}
        </div>

        {/* Footer */}
        <div className="px-8 py-4 flex-shrink-0 text-center" style={{
        borderTop: '1px solid #E8C4B8',
        background: '#F5E8E0'
      }} data-id="element-40">
          <button onClick={onClose} className="px-8 py-2.5 rounded-full text-sm font-bold tracking-wide transition-transform hover:scale-105 active:scale-95" style={{
          background: 'linear-gradient(135deg, #6B2D3E 0%, #8B3A50 100%)',
          color: '#FAF6F0',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-41">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}
function useFadeIn() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.classList.add('visible');
        observer.unobserve(el);
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return ref;
}
function OrnamentDivider({
  text
}: {
  text?: string;
}) {
  return <div className="divider-ornament my-8 text-sm tracking-widest uppercase font-body" style={{
    color: '#C9A07A'
  }} data-id="element-42">
      <span data-id="element-43">✦</span>
      {text && <span style={{
      fontFamily: 'Lato, sans-serif',
      fontSize: '0.75rem',
      letterSpacing: '0.15em'
    }} data-id="element-44">
          {text}
        </span>}
      <span data-id="element-45">✦</span>
    </div>;
}
type FaqItem = {
  q: string;
  a: string;
};
function FaqAccordion({
  items
}: {
  items: FaqItem[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-46">
      {items.map((item, i) => <div key={i} className="rounded-2xl overflow-hidden border" style={{
      borderColor: '#E8C4B8',
      background: '#FFFAF6'
    }} data-id="element-47">
          <button className="w-full flex items-center justify-between px-6 py-4 text-left transition-colors" style={{
        fontFamily: 'Playfair Display, serif',
        fontSize: '1rem',
        color: '#6B2D3E',
        background: openIndex === i ? '#F5E8E0' : 'transparent'
      }} onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-48">
            <span className="font-semibold pr-4" data-id="element-49">{item.q}</span>
            {openIndex === i ? <ChevronUpIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#C9A07A'
        }} data-id="element-50" /> : <ChevronDownIcon className="w-5 h-5 flex-shrink-0" style={{
          color: '#C9A07A'
        }} data-id="element-51" />}
          </button>
          {openIndex === i && <div className="px-6 pb-5 pt-2 font-body text-sm leading-relaxed" style={{
        color: '#2C1810',
        fontFamily: 'Lato, sans-serif'
      }} data-id="element-52">
              {item.a}
            </div>}
        </div>)}
    </div>;
}
function scrollToOferta() {
  document.getElementById('oferta')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function LibidoExpressPage() {
  const heroRef = useFadeIn();
  const hookRef = useFadeIn();
  const problemRef = useFadeIn();
  const whyRef = useFadeIn();
  const mechanismRef = useFadeIn();
  const whatRef = useFadeIn();
  const whoRef = useFadeIn();
  const howRef = useFadeIn();
  const proofRef = useFadeIn();
  const faqRef = useFadeIn();
  const offerRef = useFadeIn();
  const [legalModal, setLegalModal] = useState<ModalType>(null);
  // Initialize Meta Pixel & fire PageView
  useEffect(() => {
    initFacebookPixel();
  }, []);
  const handleAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Libido Express',
        content_type: 'product',
        value: 5.55,
        currency: 'USD'
      });
    }
  };
  const faqItems: FaqItem[] = [{
    q: '¿Es seguro si estoy en la menopausia?',
    a: 'Sí, está diseñado específicamente para esta etapa. El protocolo trabaja en armonía con los cambios hormonales naturales de la menopausia, sin interferir con ningún proceso biológico.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No, los nutrientes recomendados son accesibles y naturales. La mayoría se encuentran en tiendas de salud o supermercados a precios razonables.'
  }, {
    q: '¿Es un contenido discreto?',
    a: 'Sí, el manual es digital y puedes leerlo en cualquier dispositivo de forma completamente privada. No hay envíos físicos ni cargos visibles en tu estado de cuenta.'
  }, {
    q: '¿Funciona si llevo años con este problema?',
    a: 'Sí, la biología de tus tejidos puede responder positivamente en cualquier momento si le das los estímulos correctos. Muchas mujeres notan cambios desde la primera semana.'
  }];
  return <div className="w-full min-h-screen" style={{
    background: '#FAF6F0',
    color: '#2C1810'
  }} data-id="element-53">
      {/* Legal Modal */}
      {legalModal && <LegalModal type={legalModal} onClose={() => setLegalModal(null)} data-id="element-54" />}

      {/* Sticky Announcement Bar */}
      <div className="sticky top-0 z-50 w-full py-2.5 px-4 text-center text-sm font-semibold tracking-wide" style={{
      background: '#C9A07A',
      color: '#2C1810',
      fontFamily: 'Lato, sans-serif'
    }} data-id="element-55">
        🌸 Oferta de Lanzamiento: Solo <strong data-id="element-56">$5.55 USD</strong> — Acceso
        Instantáneo &nbsp;·&nbsp; Precio sube pronto
      </div>

      {/* HERO SECTION */}
      <section ref={heroRef} className="section-fade w-full pt-12 pb-16 px-4" style={{
      background: 'linear-gradient(160deg, #FAF6F0 0%, #F5E8E0 60%, #EDD5C8 100%)'
    }} data-id="element-57">
        <div className="max-w-5xl mx-auto" data-id="element-58">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-59">
            {/* Text */}
            <div className="flex-1 text-center lg:text-left" data-id="element-60">
              <div className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-6" style={{
              background: '#E8C4B8',
              color: '#6B2D3E',
              fontFamily: 'Lato, sans-serif'
            }} data-id="element-61">
                ✦ Protocolo Digital para Mujer Madura ✦
              </div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-5" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-62">
                Libido Express: El Protocolo de Reconexión Íntima para la Mujer
                45+
              </h1>
              <p className="text-lg sm:text-xl leading-relaxed mb-8" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728',
              fontWeight: 300
            }} data-id="element-63">
                Recupera tu deseo natural, elimina la sequedad y vuelve a
                disfrutar de tu intimidad en{' '}
                <strong style={{
                fontWeight: 700
              }} data-id="element-64">
                  14 días
                </strong>{' '}
                (sin fármacos ni hormonas sintéticas).
              </p>

              {/* HERO CTA Button - scrolls to offer section */}
              <button type="button" onClick={scrollToOferta} className="inline-block w-full sm:w-auto text-center px-8 py-4 rounded-full text-base font-bold tracking-wide transition-transform hover:scale-105 active:scale-95 shadow-lg mb-6 cursor-pointer border-none" style={{
              background: 'linear-gradient(135deg, #6B2D3E 0%, #8B3A50 50%, #6B2D3E 100%)',
              color: '#FAF6F0',
              fontFamily: 'Lato, sans-serif',
              backgroundSize: '200% auto',
              animation: 'shimmer 3s linear infinite',
              boxShadow: '0 8px 32px rgba(107,45,62,0.35)'
            }} data-id="element-65">
                DESCARGAR LIBIDO EXPRESS AHORA
              </button>

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-2" data-id="element-66">
                <div className="flex items-center gap-1.5 text-xs font-semibold" style={{
                color: '#6B2D3E',
                fontFamily: 'Lato, sans-serif'
              }} data-id="element-67">
                  <ShieldCheckIcon className="w-4 h-4" style={{
                  color: '#C9A07A'
                }} data-id="element-68" />
                  Pago Seguro
                </div>
                <div className="flex items-center gap-1.5 text-xs font-semibold" style={{
                color: '#6B2D3E',
                fontFamily: 'Lato, sans-serif'
              }} data-id="element-69">
                  <SmartphoneIcon className="w-4 h-4" style={{
                  color: '#C9A07A'
                }} data-id="element-70" />
                  Acceso Instantáneo
                </div>
                <div className="flex items-center gap-1.5 text-xs font-semibold" style={{
                color: '#6B2D3E',
                fontFamily: 'Lato, sans-serif'
              }} data-id="element-71">
                  <LeafIcon className="w-4 h-4" style={{
                  color: '#C9A07A'
                }} data-id="element-72" />
                  100% Natural
                </div>
                <div className="flex items-center gap-1.5 text-xs font-semibold" style={{
                color: '#6B2D3E',
                fontFamily: 'Lato, sans-serif'
              }} data-id="element-73">
                  <LockIcon className="w-4 h-4" style={{
                  color: '#C9A07A'
                }} data-id="element-74" />
                  Privacidad Total
                </div>
              </div>
            </div>

            {/* Product Image */}
            <div className="flex-shrink-0 w-full max-w-xs lg:max-w-sm" data-id="element-75">
              <div className="relative" data-id="element-76">
                <div className="absolute inset-0 rounded-3xl blur-2xl opacity-30" style={{
                background: 'radial-gradient(circle, #C9A07A, #E8C4B8)'
              }} data-id="element-77" />
                <img src="https://cdn.magicpatterns.com/uploads/iSwh1sLt2pH6JsSnPocYPi/heylloyd-image-1772562227069.png" alt="Libido Express - Manual Digital en tablet" className="relative w-full rounded-2xl shadow-2xl" style={{
                boxShadow: '0 24px 60px rgba(107,45,62,0.2)'
              }} data-id="element-78" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OPENING HOOK */}
      <section ref={hookRef} className="section-fade w-full py-16 px-4" style={{
      background: '#F5E8E0'
    }} data-id="element-79">
        <div className="max-w-3xl mx-auto text-center" data-id="element-80">
          <OrnamentDivider text="Tu historia" data-id="element-81" />
          <blockquote className="text-xl sm:text-2xl lg:text-3xl italic leading-relaxed mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-82">
            "Si has empezado a evitar el contacto con tu pareja no por falta de
            amor, sino por miedo a la incomodidad, al dolor o a esa sensación de
            estar <em data-id="element-83">apagada</em>..."
          </blockquote>
          <p className="text-base sm:text-lg leading-relaxed" style={{
          fontFamily: 'Lato, sans-serif',
          color: '#4A3728',
          fontWeight: 300
        }} data-id="element-84">
            No estás sola. Millones de mujeres atraviesan este cambio en
            silencio, creyendo que es una parte inevitable de la edad.
          </p>
          <p className="text-xl sm:text-2xl font-bold mt-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-85">
            No lo es.
          </p>
          <OrnamentDivider data-id="element-86" />
        </div>
      </section>

      {/* THE PROBLEM */}
      <section ref={problemRef} className="section-fade w-full py-16 px-4" style={{
      background: '#FAF6F0'
    }} data-id="element-87">
        <div className="max-w-3xl mx-auto" data-id="element-88">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-89">
            Lo que nadie te dice sobre los 45+
          </h2>
          <OrnamentDivider data-id="element-90" />
          <p className="text-base sm:text-lg leading-relaxed mb-8 text-center" style={{
          fontFamily: 'Lato, sans-serif',
          color: '#4A3728',
          fontWeight: 300
        }} data-id="element-91">
            Después de los 45 años, tu cuerpo cambia las reglas del juego. La
            caída del estrógeno no solo afecta tu energía...
          </p>

          <div className="grid sm:grid-cols-1 gap-4" data-id="element-92">
            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFF0EC',
            border: '1px solid #E8C4B8'
          }} data-id="element-93">
              <span className="text-2xl flex-shrink-0" data-id="element-94">💧</span>
              <div data-id="element-95">
                <p className="font-semibold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-96">
                  Sequedad interna
                </p>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-97">
                  La caída del estrógeno seca tus tejidos, apaga tu respuesta
                  sensorial y eleva el cortisol — la hormona del estrés que
                  "mata" el deseo antes de que siquiera aparezca.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFF0EC',
            border: '1px solid #E8C4B8'
          }} data-id="element-98">
              <span className="text-2xl flex-shrink-0" data-id="element-99">🌫️</span>
              <div data-id="element-100">
                <p className="font-semibold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-101">
                  Desconexión del cuerpo
                </p>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-102">
                  Te sientes desconectada de tu propio cuerpo. Como si habitaras
                  un lugar que ya no reconoces ni sientes como tuyo.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFF0EC',
            border: '1px solid #E8C4B8'
          }} data-id="element-103">
              <span className="text-2xl flex-shrink-0" data-id="element-104">🩹</span>
              <div data-id="element-105">
                <p className="font-semibold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-106">
                  Los parches no funcionan
                </p>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-107">
                  Los lubricantes de farmacia son solo un parche frío y pegajoso
                  que no soluciona el ardor interno ni la raíz del problema.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFF0EC',
            border: '1px solid #E8C4B8'
          }} data-id="element-108">
              <span className="text-2xl flex-shrink-0" data-id="element-109">💔</span>
              <div data-id="element-110">
                <p className="font-semibold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-111">
                  La culpa silenciosa
                </p>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-112">
                  Sientes la culpa de querer querer, pero que tu cuerpo
                  simplemente no responda. Y eso duele más que cualquier síntoma
                  físico.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <section ref={whyRef} className="section-fade w-full py-16 px-4" style={{
      background: 'linear-gradient(180deg, #EDD5C8 0%, #F5E8E0 100%)'
    }} data-id="element-113">
        <div className="max-w-3xl mx-auto" data-id="element-114">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-115">
            Por qué lo que intentaste no funcionó
          </h2>
          <OrnamentDivider data-id="element-116" />

          <div className="space-y-4" data-id="element-117">
            <div className="flex items-start gap-3" data-id="element-118">
              <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#9B4455'
            }} data-id="element-119" />
              <p className="text-sm sm:text-base leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-120">
                <strong data-id="element-121">Los lubricantes tradicionales</strong> solo cubren el
                síntoma superficial, pero ignoran la atrofia de los tejidos
                internos.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-122">
              <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#9B4455'
            }} data-id="element-123" />
              <p className="text-sm sm:text-base leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-124">
                <strong data-id="element-125">Los suplementos de "energía" genéricos</strong> no están
                diseñados para la complejidad hormonal de la mujer madura.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-126">
              <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#9B4455'
            }} data-id="element-127" />
              <p className="text-sm sm:text-base leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-128">
                <strong data-id="element-129">Intentar "forzar" el deseo</strong> solo aumenta tu
                estrés, lo que bloquea aún más la respuesta física de tu cuerpo.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-130">
              <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
              color: '#9B4455'
            }} data-id="element-131" />
              <p className="text-sm sm:text-base leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-132">
                <strong data-id="element-133">Esperar a que "pase solo"</strong> solo incrementa la
                distancia emocional con tu pareja y profundiza el problema.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THE UNIQUE MECHANISM */}
      <section ref={mechanismRef} className="section-fade w-full py-16 px-4" style={{
      background: '#FAF6F0'
    }} data-id="element-134">
        <div className="max-w-3xl mx-auto text-center" data-id="element-135">
          <div className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4" style={{
          background: '#E8C4B8',
          color: '#6B2D3E',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-136">
            ✦ La Diferencia ✦
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-137">
            El Método de Bio-Hidratación Celular
          </h2>
          <OrnamentDivider data-id="element-138" />

          <div className="p-8 rounded-3xl text-left" style={{
          background: 'linear-gradient(135deg, #6B2D3E 0%, #8B3A50 100%)',
          color: '#FAF6F0'
        }} data-id="element-139">
            <p className="text-base sm:text-lg leading-relaxed mb-6" style={{
            fontFamily: 'Lato, sans-serif',
            fontWeight: 300
          }} data-id="element-140">
              A diferencia de las soluciones tópicas, este protocolo trabaja{' '}
              <strong style={{
              fontWeight: 700
            }} data-id="element-141">
                desde el torrente sanguíneo hacia afuera
              </strong>
              .
            </p>
            <p className="text-base sm:text-lg leading-relaxed" style={{
            fontFamily: 'Lato, sans-serif',
            fontWeight: 300
          }} data-id="element-142">
              Utilizamos nutrientes específicos como el{' '}
              <strong style={{
              fontWeight: 700
            }} data-id="element-143">
                Omega-7
              </strong>{' '}
              y técnicas de{' '}
              <strong style={{
              fontWeight: 700
            }} data-id="element-144">
                "Reset del Nervio Vago"
              </strong>{' '}
              para hidratar las mucosas desde la raíz y apagar el estado de
              alerta del cerebro, permitiendo que la lubricación y el deseo
              fluyan de forma{' '}
              <em style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '1.1em'
            }} data-id="element-145">
                biológica y espontánea
              </em>
              .
            </p>
          </div>
        </div>
      </section>

      {/* WHAT YOU GET */}
      <section ref={whatRef} className="section-fade w-full py-16 px-4" style={{
      background: '#F5E8E0'
    }} data-id="element-146">
        <div className="max-w-3xl mx-auto" data-id="element-147">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-148">
            Todo lo que recibes hoy
          </h2>
          <OrnamentDivider data-id="element-149" />

          <div className="space-y-4" data-id="element-150">
            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFFAF6',
            border: '1px solid #C9A07A'
          }} data-id="element-151">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg" style={{
              background: '#6B2D3E',
              color: '#FAF6F0'
            }} data-id="element-152">
                📖
              </div>
              <div data-id="element-153">
                <p className="font-bold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-154">
                  El Manual Digital "Libido Express"
                </p>
                <p className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-155">
                  Formato PDF de lectura rápida. Claro, directo y diseñado para
                  que puedas empezar hoy mismo.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFFAF6',
            border: '1px solid #C9A07A'
          }} data-id="element-156">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg" style={{
              background: '#6B2D3E',
              color: '#FAF6F0'
            }} data-id="element-157">
                🌿
              </div>
              <div data-id="element-158">
                <p className="font-bold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-159">
                  El Protocolo de Nutrición de Mucosas
                </p>
                <p className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-160">
                  Lista completa de suplementos y alimentos clave para hidratar
                  tus tejidos desde adentro.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFFAF6',
            border: '1px solid #C9A07A'
          }} data-id="element-161">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg" style={{
              background: '#6B2D3E',
              color: '#FAF6F0'
            }} data-id="element-162">
                🌬️
              </div>
              <div data-id="element-163">
                <p className="font-bold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-164">
                  La Técnica de Respiración Pélvica de 60 Segundos
                </p>
                <p className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-165">
                  Para eliminar el bloqueo por estrés y abrir la puerta al deseo
                  de forma inmediata.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFFAF6',
            border: '1px solid #C9A07A'
          }} data-id="element-166">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg" style={{
              background: '#6B2D3E',
              color: '#FAF6F0'
            }} data-id="element-167">
                📅
              </div>
              <div data-id="element-168">
                <p className="font-bold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-169">
                  El Plan de Acción Paso a Paso de 14 Días
                </p>
                <p className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-170">
                  Para la reconexión total. Sin presión, sin complicaciones, con
                  resultados reales.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-5 rounded-2xl" style={{
            background: '#FFFAF6',
            border: '1px solid #C9A07A'
          }} data-id="element-171">
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg" style={{
              background: '#6B2D3E',
              color: '#FAF6F0'
            }} data-id="element-172">
                💧
              </div>
              <div data-id="element-173">
                <p className="font-bold mb-1" style={{
                fontFamily: 'Playfair Display, serif',
                color: '#6B2D3E'
              }} data-id="element-174">
                  Guía de Hidratación Externa Segura
                </p>
                <p className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-175">
                  Ingredientes naturales que sí funcionan, sin químicos
                  agresivos ni efectos secundarios.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO THIS IS FOR / NOT FOR */}
      <section ref={whoRef} className="section-fade w-full py-16 px-4" style={{
      background: '#FAF6F0'
    }} data-id="element-176">
        <div className="max-w-4xl mx-auto" data-id="element-177">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-178">
            ¿Es esto para ti?
          </h2>
          <OrnamentDivider data-id="element-179" />

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-180">
            {/* For */}
            <div className="p-6 rounded-3xl" style={{
            background: 'linear-gradient(135deg, #F5E8E0, #EDD5C8)',
            border: '1px solid #C9A07A'
          }} data-id="element-181">
              <h3 className="text-lg font-bold mb-4 flex items-center gap-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-182">
                <CheckIcon className="w-5 h-5" style={{
                color: '#6B2D3E'
              }} data-id="element-183" />
                Sí es para ti si...
              </h3>
              <ul className="space-y-3" data-id="element-184">
                <li className="flex items-start gap-2" data-id="element-185">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#C9A07A'
                }} data-id="element-186" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-187">
                    Tienes entre 45 y 65 años y notas sequedad o incomodidad
                    física
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-188">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#C9A07A'
                }} data-id="element-189" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-190">
                    Sientes que tu deseo se ha "apagado" sin explicación
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-191">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#C9A07A'
                }} data-id="element-192" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-193">
                    Quieres recuperar tu chispa sin recurrir a fármacos químicos
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-194">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#C9A07A'
                }} data-id="element-195" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-196">
                    Buscas soluciones naturales basadas en la biología femenina
                  </span>
                </li>
              </ul>
            </div>

            {/* Not for */}
            <div className="p-6 rounded-3xl" style={{
            background: '#FFFAF6',
            border: '1px solid #E8C4B8'
          }} data-id="element-197">
              <h3 className="text-lg font-bold mb-4 flex items-center gap-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#9B4455'
            }} data-id="element-198">
                <XIcon className="w-5 h-5" style={{
                color: '#9B4455'
              }} data-id="element-199" />
                No es para ti si...
              </h3>
              <ul className="space-y-3" data-id="element-200">
                <li className="flex items-start gap-2" data-id="element-201">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#9B4455'
                }} data-id="element-202" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-203">
                    Buscas una "pastilla mágica" instantánea sin cambiar tus
                    hábitos
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-204">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#9B4455'
                }} data-id="element-205" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-206">
                    Requieres intervención quirúrgica médica de urgencia
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-207">
                  <XIcon className="w-4 h-4 mt-0.5 flex-shrink-0" style={{
                  color: '#9B4455'
                }} data-id="element-208" />
                  <span className="text-sm" style={{
                  fontFamily: 'Lato, sans-serif',
                  color: '#4A3728'
                }} data-id="element-209">
                    No estás dispuesta a dedicar 5 minutos al día a tu bienestar
                    íntimo
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section ref={howRef} className="section-fade w-full py-16 px-4" style={{
      background: 'linear-gradient(180deg, #EDD5C8 0%, #F5E8E0 100%)'
    }} data-id="element-210">
        <div className="max-w-3xl mx-auto text-center" data-id="element-211">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-212">
            Así funciona el protocolo
          </h2>
          <OrnamentDivider data-id="element-213" />

          <div className="grid sm:grid-cols-3 gap-6 mt-4" data-id="element-214">
            <div className="flex flex-col items-center text-center" data-id="element-215">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 font-bold" style={{
              background: '#6B2D3E',
              color: '#FAF6F0',
              fontFamily: 'Playfair Display, serif',
              fontSize: '1.5rem'
            }} data-id="element-216">
                1
              </div>
              <h3 className="text-lg font-bold mb-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-217">
                Hidratas
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-218">
                Sigues el protocolo nutricional para nutrir tus tejidos desde
                adentro con los nutrientes correctos.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-219">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 font-bold" style={{
              background: '#C9A07A',
              color: '#FAF6F0',
              fontFamily: 'Playfair Display, serif',
              fontSize: '1.5rem'
            }} data-id="element-220">
                2
              </div>
              <h3 className="text-lg font-bold mb-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-221">
                Calmas
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-222">
                Aplicas las técnicas de respiración para bajar el cortisol y
                abrir la puerta al deseo natural.
              </p>
            </div>
            <div className="flex flex-col items-center text-center" data-id="element-223">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-4 font-bold" style={{
              background: '#E8C4B8',
              color: '#6B2D3E',
              fontFamily: 'Playfair Display, serif',
              fontSize: '1.5rem'
            }} data-id="element-224">
                3
              </div>
              <h3 className="text-lg font-bold mb-2" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-225">
                Conectas
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-226">
                Sigues el plan de 14 días de re-sensibilización gradual sin
                presión ni expectativas artificiales.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PROOF / BELIEVABILITY */}
      <section ref={proofRef} className="section-fade w-full py-16 px-4" style={{
      background: '#FAF6F0'
    }} data-id="element-227">
        <div className="max-w-3xl mx-auto text-center" data-id="element-228">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-229">
            Lo que puedes esperar
          </h2>
          <OrnamentDivider data-id="element-230" />
          <div className="p-8 rounded-3xl relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #6B2D3E 0%, #4A1E2B 100%)'
        }} data-id="element-231">
            <div className="absolute top-0 right-0 w-32 h-32 rounded-full opacity-10" style={{
            background: '#C9A07A',
            transform: 'translate(30%, -30%)'
          }} data-id="element-232" />
            <p className="text-4xl font-bold mb-2" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#C9A07A'
          }} data-id="element-233">
              7 días
            </p>
            <p className="text-lg sm:text-xl italic mb-4" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#FAF6F0'
          }} data-id="element-234">
              La mayoría de las mujeres reportan una disminución notable en la
              sensación de ardor y un aumento en la elasticidad de los tejidos.
            </p>
            <div className="w-16 h-px mx-auto mb-4" style={{
            background: '#C9A07A'
          }} data-id="element-235" />
            <p className="text-4xl font-bold mb-2" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#E8C4B8'
          }} data-id="element-236">
              14 días
            </p>
            <p className="text-base sm:text-lg" style={{
            fontFamily: 'Lato, sans-serif',
            color: '#FAF6F0',
            fontWeight: 300
          }} data-id="element-237">
              El terreno está preparado para una intimidad plena y sin dolor.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section ref={faqRef} className="section-fade w-full py-16 px-4" style={{
      background: '#F5E8E0'
    }} data-id="element-238">
        <div className="max-w-3xl mx-auto" data-id="element-239">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-240">
            Preguntas frecuentes
          </h2>
          <OrnamentDivider data-id="element-241" />
          <FaqAccordion items={faqItems} data-id="element-242" />
        </div>
      </section>

      {/* OFFER + PRICE BLOCK + FINAL CTA */}
      <section id="oferta" ref={offerRef} className="section-fade w-full py-20 px-4" style={{
      background: 'linear-gradient(160deg, #FAF6F0 0%, #F5E8E0 50%, #EDD5C8 100%)'
    }} data-id="element-243">
        <div className="max-w-2xl mx-auto text-center" data-id="element-244">
          <div className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-6" style={{
          background: '#E8C4B8',
          color: '#6B2D3E',
          fontFamily: 'Lato, sans-serif'
        }} data-id="element-245">
            ✦ Oferta Especial de Lanzamiento ✦
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#6B2D3E'
        }} data-id="element-246">
            Recupera tu vitalidad y tu confianza íntima hoy mismo
          </h2>
          <p className="text-base sm:text-lg leading-relaxed mb-8" style={{
          fontFamily: 'Lato, sans-serif',
          color: '#4A3728',
          fontWeight: 300
        }} data-id="element-247">
            No permitas que el silencio apague tu relación. Tu bienestar íntimo
            es un derecho, no un lujo.
          </p>

          {/* Price Box */}
          <div className="p-8 rounded-3xl mb-8 relative overflow-hidden" style={{
          background: '#FFFAF6',
          border: '2px solid #C9A07A',
          boxShadow: '0 16px 48px rgba(107,45,62,0.15)'
        }} data-id="element-248">
            <div className="absolute top-0 left-0 w-full h-1 rounded-t-3xl" style={{
            background: 'linear-gradient(90deg, #C9A07A, #6B2D3E, #C9A07A)'
          }} data-id="element-249" />
            <p className="text-sm font-semibold tracking-widest uppercase mb-2" style={{
            fontFamily: 'Lato, sans-serif',
            color: '#C9A07A'
          }} data-id="element-250">
              Precio Especial de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-251">
              <span className="text-lg line-through opacity-50" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-252">
                $47.00 USD
              </span>
              <span className="text-5xl sm:text-6xl font-bold" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#6B2D3E'
            }} data-id="element-253">
                $5.55
              </span>
              <span className="text-lg" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#4A3728'
            }} data-id="element-254">
                USD
              </span>
            </div>
            <p className="text-sm mb-6" style={{
            fontFamily: 'Lato, sans-serif',
            color: '#9B4455'
          }} data-id="element-255">
              ⚡ Este precio sube pronto — no lo dejes para después
            </p>

            {/* What's included summary */}
            <div className="text-left space-y-2 mb-6" data-id="element-256">
              <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#C9A07A'
            }} data-id="element-257">
                Incluye todo esto:
              </p>
              <div className="flex items-center gap-2" data-id="element-258">
                <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                color: '#C9A07A'
              }} data-id="element-259" />
                <span className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-260">
                  Manual Digital "Libido Express" (PDF)
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-261">
                <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                color: '#C9A07A'
              }} data-id="element-262" />
                <span className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-263">
                  Protocolo de Nutrición de Mucosas
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-264">
                <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                color: '#C9A07A'
              }} data-id="element-265" />
                <span className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-266">
                  Técnica de Respiración Pélvica de 60 Segundos
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-267">
                <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                color: '#C9A07A'
              }} data-id="element-268" />
                <span className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-269">
                  Plan de Acción de 14 Días
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-270">
                <CheckIcon className="w-4 h-4 flex-shrink-0" style={{
                color: '#C9A07A'
              }} data-id="element-271" />
                <span className="text-sm" style={{
                fontFamily: 'Lato, sans-serif',
                color: '#4A3728'
              }} data-id="element-272">
                  Guía de Hidratación Externa Segura
                </span>
              </div>
            </div>

            {/* OFFER CTA Button - goes to cart */}
            <a href="https://flujovital.com/cart/50801780687152:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="inline-block w-full sm:w-auto text-center px-8 py-4 rounded-full text-base font-bold tracking-wide transition-transform hover:scale-105 active:scale-95 shadow-lg mb-6" style={{
            background: 'linear-gradient(135deg, #6B2D3E 0%, #8B3A50 50%, #6B2D3E 100%)',
            color: '#FAF6F0',
            fontFamily: 'Lato, sans-serif',
            backgroundSize: '200% auto',
            animation: 'shimmer 3s linear infinite',
            boxShadow: '0 8px 32px rgba(107,45,62,0.35)'
          }} data-id="element-273">
              DESCARGAR LIBIDO EXPRESS AHORA — $5.55 USD
            </a>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-274">
              <div className="flex items-center gap-2 text-sm" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#6B2D3E'
            }} data-id="element-275">
                <ShieldCheckIcon className="w-5 h-5" style={{
                color: '#C9A07A'
              }} data-id="element-276" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center gap-2 text-sm" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#6B2D3E'
            }} data-id="element-277">
                <SmartphoneIcon className="w-5 h-5" style={{
                color: '#C9A07A'
              }} data-id="element-278" />
                Acceso Instantáneo
              </div>
              <div className="flex items-center gap-2 text-sm" style={{
              fontFamily: 'Lato, sans-serif',
              color: '#6B2D3E'
            }} data-id="element-279">
                <LockIcon className="w-5 h-5" style={{
                color: '#C9A07A'
              }} data-id="element-280" />
                Privacidad Total
              </div>
            </div>

            <p className="text-lg font-bold italic" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#6B2D3E'
          }} data-id="element-281">
              ✦ Reclama tu derecho al placer. ✦
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-10 px-4 text-center" style={{
      background: '#2C1810',
      color: '#C9A07A'
    }} data-id="element-282">
        <p className="text-sm mb-4" style={{
        fontFamily: 'Lato, sans-serif',
        fontWeight: 300
      }} data-id="element-283">
          © 2025 Libido Express · Todos los derechos reservados · Contenido
          digital para uso personal
        </p>
        <div className="flex items-center justify-center gap-6 mb-4" data-id="element-284">
          <button onClick={() => setLegalModal('privacy')} className="text-xs underline underline-offset-2 transition-opacity hover:opacity-70" style={{
          fontFamily: 'Lato, sans-serif',
          color: '#C9A07A'
        }} data-id="element-285">
            Política de Privacidad
          </button>
          <span style={{
          color: '#6B4A3A'
        }} data-id="element-286">
            ·
          </span>
          <button onClick={() => setLegalModal('terms')} className="text-xs underline underline-offset-2 transition-opacity hover:opacity-70" style={{
          fontFamily: 'Lato, sans-serif',
          color: '#C9A07A'
        }} data-id="element-287">
            Términos de Uso
          </button>
        </div>
        <p className="text-xs opacity-50" style={{
        fontFamily: 'Lato, sans-serif',
        color: '#FAF6F0'
      }} data-id="element-288">
          Este producto es de carácter informativo y no reemplaza el consejo
          médico profesional.
        </p>
      </footer>
    </div>;
}